import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volvobusforfamilytourpune() {



const cardData =
{
  keyword: 'Volvo Bus for Family Tour Pune',
  heading: 'Sanavi Travels: Volvo Bus for Family Tour Pune',
  headingDescription: 'Sanavi Travels offers premium Volvo Bus for Family Tour Pune services, ensuring safe, comfortable, and luxurious group travel for families planning sightseeing, vacations, picnics, weddings, and outstation tours from Pune with professional drivers and reliable service.',

  top: 'Best Family Travel Experiences with Volvo Bus from Pune',

  "topPlaces": [
    {
      "title": "Comfortable Family Sightseeing Tours from Pune",
      "description": "Volvo bus hire for family sightseeing tours from Pune offers an unmatched level of comfort, safety, and convenience for families of all sizes. Families can explore popular destinations such as Lonavala, Mahabaleshwar, Lavasa, Nashik, and nearby heritage spots while traveling together in a single luxury coach. Spacious pushback seats, smooth suspension, wide aisles, and large windows allow every family member, including children and senior citizens, to travel comfortably without fatigue. Parents can relax knowing the journey is safe and well-managed, while kids enjoy a smooth and enjoyable ride. Volvo buses eliminate the stress of multiple vehicles, parking issues, and navigation challenges, making family sightseeing a truly relaxed experience."
    },
    {
      "title": "Outstation Family Vacations",
      "description": "Families planning outstation vacations from Pune to Goa, Konkan, Shirdi, Pandharpur, or South Maharashtra prefer Volvo buses due to their long-distance comfort and reliability. Long journeys become enjoyable with climate-controlled interiors, stable highway performance, and professional drivers experienced in intercity routes. Families can carry sufficient luggage, food supplies, and travel essentials without space constraints. Traveling together strengthens family bonding, allows shared experiences, and ensures elders and children are not subjected to travel fatigue or inconvenience during extended road trips."
    },
    {
      "title": "Pilgrimage & Religious Family Tours",
      "description": "Volvo buses are widely chosen for family pilgrimage tours from Pune to destinations such as Shirdi, Bhimashankar, Trimbakeshwar, Ashtavinayak temples, and Pandharpur. Spiritual journeys require peaceful, disciplined, and safe travel, which Volvo buses provide through smooth rides and controlled driving. Families can focus on devotion and togetherness rather than travel stress. Senior citizens benefit from comfortable seating and minimal vibrations, while families appreciate punctual temple visits and organized travel schedules."
    },
    {
      "title": "Family Picnic & Weekend Getaways",
      "description": "For family picnics and weekend getaways, Volvo bus hire ensures a relaxed start and end to the outing. Whether visiting hill stations, resorts, amusement parks, or eco-tourism locations, families can enjoy the journey as part of the holiday. Volvo buses provide sufficient storage for picnic items, food boxes, and recreational gear. The smooth ride ensures children remain comfortable and active throughout the trip, while elders enjoy a calm and vibration-free journey."
    },
    {
      "title": "Wedding & Family Event Travel",
      "description": "Family weddings and large family events often require coordinated transportation of relatives and guests. Volvo buses are ideal for wedding-related family travel, ensuring everyone arrives together, on time, and comfortably. The luxury interiors reflect the importance of the occasion, while organized travel avoids confusion, delays, and parking hassles at venues. Families appreciate the professionalism and dignity that Volvo bus travel brings to special events."
    },
    {
      "title": "Multi-Generational Family Tours",
      "description": "Multi-generational family tours involving grandparents, parents, children, and relatives demand extra comfort and safety. Volvo buses are designed to cater to all age groups, offering easy boarding, stable rides, comfortable seating, and controlled speed. Elders can travel without joint strain, children remain comfortable, and adults enjoy a stress-free journey. This makes Volvo buses an ideal choice for extended family holidays."
    },
    {
      "title": "Safe Highway & Ghat Travel",
      "description": "Family travel often includes routes with highways, ghats, and winding roads. Volvo buses are known for superior braking systems, road grip, and stability, making them safer on such terrains. Experienced drivers trained in family and tourist travel ensure controlled driving, proper halts, and safe navigation through challenging sections, providing peace of mind to families."
    },
    {
      "title": "Luxury Travel Experience for Families",
      "description": "Volvo buses offer a premium travel experience with refined interiors, superior ride quality, and reduced noise levels. Families looking for a luxury travel experience prefer Volvo buses over standard coaches due to the comfort, elegance, and reliability they provide. The journey feels relaxed and premium, making vacations more enjoyable."
    },
    {
      "title": "Stress-Free Group Coordination",
      "description": "When families travel together in one Volvo bus, coordination becomes simple and stress-free. There is no need to manage multiple vehicles, phone calls, or regrouping at stops. Everyone travels together, eats together during breaks, and reaches destinations simultaneously, enhancing overall travel discipline and enjoyment."
    },
    {
      "title": "Doorstep Pickup & Direct Drop",
      "description": "Volvo bus hire for family tours includes convenient doorstep pickup from Pune and direct drop at destinations such as hotels, resorts, temples, or picnic spots. This eliminates the need for additional transport arrangements and ensures a seamless start-to-end family travel experience."
    }
  ],

  "services": [
    {
      "name": "Volvo Bus for Family Tour Pune",
      "description": "Sanavi Travels provides dedicated Volvo Bus for Family Tour Pune services designed to deliver maximum comfort, safety, and luxury for family travel. Our Volvo buses feature pushback seats, smooth suspension, climate-controlled interiors, and ample luggage space, making them ideal for family sightseeing, vacations, pilgrimages, weddings, and long-distance tours. Professional drivers ensure disciplined driving, planned halts, and safe navigation across highways and ghats, allowing families to relax and enjoy quality time together throughout the journey."
    },
    {
      "name": "AC Volvo Bus Family Tour Pune",
      "description": "AC Volvo buses offer a cool, quiet, and comfortable travel environment for families, especially during summer and long-distance journeys. Climate control ensures consistent comfort for children and elders, while smooth ride quality minimizes fatigue. This option is preferred by families seeking premium comfort during vacations and extended tours."
    },
    {
      "name": "Non AC Volvo Bus Family Tour Pune",
      "description": "Non AC Volvo buses provide a reliable and economical alternative for family tours during pleasant weather conditions. They retain the safety, seating comfort, and stability of Volvo vehicles while keeping rental costs manageable for budget-conscious families."
    },
    {
      "name": "Luxury Volvo Bus Hire Family Tour Pune",
      "description": "Luxury Volvo buses elevate family travel with premium interiors, superior ride quality, and elegant seating arrangements. These buses are ideal for special family occasions, destination weddings, anniversary trips, and high-end family vacations where comfort and style are equally important."
    },
    {
      "name": "32 Seater Volvo Bus Family Tour Pune",
      "description": "32 seater Volvo buses are perfect for medium-sized families and joint family groups traveling together. They offer balanced seating capacity, ample luggage space, and comfortable interiors, making them suitable for multi-day tours and long-distance family travel."
    },
    {
      "name": "35 Seater Volvo Bus Family Tour Pune",
      "description": "35 seater Volvo buses are ideal for large family groups, family reunions, and extended relatives traveling together. Everyone can travel in a single vehicle comfortably, ensuring better coordination, safety, and shared experiences."
    },
    {
      "name": "Volvo Bus for Corporate Family Tour Pune",
      "description": "Some corporate events involve family-inclusive outings and retreats. Volvo bus hire supports organized and comfortable transportation for employees and their families, maintaining professionalism while ensuring a pleasant travel experience for all participants."
    },
    {
      "name": "Volvo Bus for Group Family Tour Pune",
      "description": "Group family tours benefit greatly from Volvo buses due to their stability, comfort, and group-friendly layout. Traveling together enhances bonding, reduces travel stress, and ensures timely arrivals at all destinations."
    },
    {
      "name": "Affordable Volvo Bus Rental Family Tour Pune",
      "description": "Affordable Volvo bus rental packages are designed to provide luxury family travel at competitive pricing. Transparent costs, flexible plans, and reliable vehicles ensure excellent value without compromising safety or comfort."
    },
    {
      "name": "Best Volvo Bus Service Family Tour Pune",
      "description": "Sanavi Travels is recognized for delivering consistent quality, punctual service, and customer satisfaction in family Volvo bus travel. Our reputation is built on safety, comfort, and dependable service."
    },
    {
      "name": "Volvo Bus with Driver Family Tour Pune",
      "description": "All Volvo bus rentals include experienced drivers trained in family and tourist travel. Drivers manage traffic, highways, and ghat sections professionally, allowing families to enjoy the journey without any driving concerns."
    },
    {
      "name": "Volvo Bus for Wedding Family Tour Pune",
      "description": "Wedding-related family travel becomes smooth and dignified with Volvo buses, ensuring coordinated guest transport, comfortable seating, and on-time arrivals for all wedding functions."
    },
    {
      "name": "Volvo Bus for Picnic Family Tour Pune",
      "description": "Volvo buses are ideal for family picnic travel, providing comfort, space for picnic items, and a relaxed journey that allows families to enjoy the outing from start to finish."
    },
    {
      "name": "Volvo Bus for Sightseeing Family Tour Pune",
      "description": "Sightseeing tours become more enjoyable with Volvo buses as families can visit multiple attractions comfortably in one day without travel fatigue or coordination challenges."
    },
    {
      "name": "Volvo Bus for Outstation Family Tour Pune",
      "description": "For long-distance outstation family tours, Volvo buses provide superior comfort, safety, and stability, making extended road journeys pleasant and stress-free."
    }
  ],

  "tableData": [
    ["Volvo Family Tour Bus", "AC Volvo Bus"],
    ["Non AC Volvo Bus", "Luxury Volvo Bus"],
    ["32 Seater Volvo", "35 Seater Volvo"],
    ["Family Vacations", "Pilgrimage Tours"],
    ["Picnic Trips", "Outstation Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Family-Safe Travel", "WhyChoosedescription": "Designed for children, elders, and adults alike." },
    { "WhyChooseheading": "Luxury & Comfort", "WhyChoosedescription": "Premium seating and smooth ride quality." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Professionals trained for family and tourist travel." },
    { "WhyChooseheading": "Reliable Fleet", "WhyChoosedescription": "Well-maintained Volvo buses with safety checks." },
    { "WhyChooseheading": "Flexible Itineraries", "WhyChoosedescription": "Custom routes and sightseeing plans." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear costs with no hidden charges." },
    { "WhyChooseheading": "Group Coordination", "WhyChoosedescription": "Entire family travels together comfortably." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for dependable service." }
  ]
};

const faqData = [
  { question: 'Do you provide Volvo bus for family tours from Pune?', answer: 'Yes, Sanavi Travels offers Volvo bus hire for family tours from Pune.' },
  { question: 'Is Volvo bus suitable for senior citizens?', answer: 'Yes, Volvo buses provide smooth rides and comfortable seating for elders.' },
  { question: 'What seating options are available?', answer: '32 seater and 35 seater Volvo buses are available.' },
  { question: 'Are drivers experienced for family travel?', answer: 'Yes, drivers are trained and experienced in family and tourist routes.' },
  { question: 'Can we customize the itinerary?', answer: 'Yes, routes and sightseeing stops can be customized.' },
  { question: 'Is AC available in Volvo buses?', answer: 'Yes, AC Volvo buses are available.' },
  { question: 'Is luggage space sufficient?', answer: 'Yes, Volvo buses provide ample luggage space.' },
  { question: 'Do you offer wedding family transport?', answer: 'Yes, Volvo buses are available for wedding family travel.' },
  { question: 'Is Volvo bus travel safe for long distances?', answer: 'Yes, Volvo buses are designed for safe long-distance travel.' },
  { question: 'How can I book a Volvo bus for family tour?', answer: 'You can book via our website or customer support.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Our family tour in a Volvo bus from Pune was extremely comfortable and enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Excellent service, clean bus, and very professional driver. Perfect for family travel.',
    rating: 5
  }
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus for Family Tour Pune - Sanavi Travels",
  "description": "Sanavi Travels offers Volvo buses for family tours in Pune, including corporate family trips, group tours, weddings, picnics, sightseeing, and outstation travel. AC and Non-AC options, luxury buses, 32-seater and 35-seater configurations are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Volvo Bus for Family Tour Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Volvo buses for family tours in Pune with Sanavi Travels. AC & Non-AC luxury buses, 32-seater and 35-seater options for family trips, corporate travel, group tours, weddings, picnics, sightseeing, and outstation travel with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/288.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Volvobusforfamilytourpune;